// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1iS5m","unreadBadge":"styles_unreadBadge__2ExQ0","modalContent":"styles_modalContent__17nYN","modal":"styles_modal__31kWe"};